module.exports = __webpack_public_path__ + "5e1bfead99f976aaa2b38f2877e1e560.png";